<script lang="ts" setup>
import VInputMask from '@shared/form/VInputMask/VInputMask.vue';

export interface Props {
  value?: string;
  path?: string;
  placeholder?: string;
  disabled?: boolean;
  hasError?: boolean;
  readonly?: boolean;
  id?: string;
}

const props = withDefaults(defineProps<Props>(), {
  disabled: false,
  hasError: false,
  readonly: false,
});

const emit = defineEmits<{
  updateField: [{ path: string | undefined; value: string | undefined }];
  blur: [];
}>();

const postcode = defineModel<string | undefined>();

const mask = '#### @@';

const updatePostcode = (val: string | null | undefined) => {
  postcode.value = val?.toLocaleUpperCase();
  emit('updateField', { path: props.path, value: postcode.value });
};
</script>
<template>
  <VInputMask
    v-if="!readonly"
    @update:model-value="updatePostcode"
    :model-value="postcode"
    @blur="emit('blur')"
    class="uppercase"
    :disabled
    :pt="{ root: { id } }"
    :mask
    :has-error
    :placeholder="placeholder ? placeholder : '1234 AB'"
  />
  <div v-else class="filled group-[]/float-label:h-11 group-[]/float-label:content-center">
    {{ postcode || '-' }}
  </div>
</template>
